import {Card, CardHeader, CardBody, Button, Form, FormGroup, Label, Input, Alert} from "reactstrap";

import {connect, ConnectedProps} from "react-redux";
import {Dispatch} from "redux";
import {RootState} from "../../redux/store";
import React from "react";
import {
    getItems,
    getListItemTitles, getListTaskTitles,
} from "../../redux/data/data.reducer";
import {addTask} from "../../redux/data/data.actions";
import {Item} from "../../dataTypes";

class AddTask extends React.Component<PropsFromRedux & AddTaskProps, AddTaskState> {

    constructor(props: PropsFromRedux & AddTaskProps) {
        super(props);

        this.state = {
            title: '',
            duration: 0,
            error: null,
            itemID: this.props.items[0] ? this.props.items[0].id : -1
        }
    }

    render() {
        return this.props.items.length < 1 ? <></> : (
            <>
                <Card className={this.props.className}>
                    <CardHeader>
                        Add a new Task
                    </CardHeader>
                    <CardBody>
                        <Form>
                            <FormGroup>
                                <Label for="itemSelect">Select an Item</Label>
                                <Input type="select" name="select" id="itemSelect"
                                       onChange={event => this.setItemIdFromTitle(event.target.value)}>
                                    {this.props.items.map((item: Item) => {
                                        return (
                                            <option key={item.id}>
                                                {item.title}
                                            </option>
                                        )
                                    })}

                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label for="taskTitle">Title</Label>
                                <Input type="text" name="title" id="taskTitle"
                                       placeholder="Task Title"
                                       onChange={(event => this.setTitle(event.target.value))}/>
                            </FormGroup>
                            <FormGroup>
                                <Label className={"pb-1"} for="">Estimated Duration in Hours</Label>
                                <Input type="number" name="duration" id="duration"
                                       placeholder={"20"}
                                       onChange={event => this.setDuration(event.target.valueAsNumber)}/>
                            </FormGroup>
                            {this.state.error ? <Alert style={{textAlign: "center"}} className={"my-2"}
                                                       color={"danger"}>{this.state.error}</Alert> : <></>}
                            <Button name="addItem" id="addItem" onClick={() => this.submitForm()}>Add Task</Button>
                        </Form>
                    </CardBody>
                </Card>
            </>
        )
    }


    setError(newError: string | null) {
        this.setState({error: newError})
    }

    setItemId(itemID: number) {
        this.setState({itemID})
    }

    setItemIdFromTitle(itemTitle: string) {
        console.log("changed item id")
        this.props.items.forEach((item) => {
            if (item.title === itemTitle) this.setItemId(item.id)
        })
    }

    setDuration(duration: number) {
        if (isNaN(duration)) duration = 0;
        this.setState({duration})
    }

    setTitle(title: string) {
        this.setState({title})
    }

    submitForm = () => {


        if (this.state.title === "") {
            this.setError("Title is required");
            return;
        }
        if (this.state.duration <= 0) {
            this.setError("Duration must be greater than 0");
            return;
        }
        if (!this.props.items.map(item => item.id).includes(this.state.itemID)) {
            this.setError("Item with id " + this.state.itemID + ' doesn\'t exist');
            return;
        }
        if (this.props.listTaskTitles.includes(this.state.title)) {
            this.setError('Task with Title: "' + this.state.title + '" exists already.')
            return
        }
        this.props.onAddTask(this.state.itemID, this.state.title, this.state.duration);
        this.setError(null);
    };


}

const mapState = (state: RootState) => {
    return {
        listTaskTitles: getListTaskTitles(state.data),
        listItemTitles: getListItemTitles(state.data),
        items: getItems(state.data)
    }
}

const mapDispatch = (dispatch: Dispatch) => {


    return {
        onAddTask: (itemID: number, title: string, duration: number) => dispatch(addTask(itemID, title, duration)),
    }
}

const connector = connect(
    mapState,
    mapDispatch
)

interface AddTaskProps {
    className?: string
}

interface AddTaskState {
    title: string,
    duration: number,
    error: string | null
    itemID: number
}

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AddTask)